"use client"

import React from "react"
import Link, { useLinkStatus } from "next/link"
import { usePathname } from "next/navigation"

import { Tabs, TabsList, TabsTrigger } from "@shared/ui"

export type Tab = {
  value: string
  label: string
}

const TabLink = ({ tab }: { tab: Tab }) => {
  return (
    <Link href={tab.value}>
      <TabLinkContent tab={tab} />
    </Link>
  )
}

const TabLinkContent = ({ tab }: { tab: Tab }) => {
  const { pending } = useLinkStatus()

  return (
    <TabsTrigger value={tab.value}>
      {tab.label}
      {pending && (
        <div className="ml-1.5 h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
    </TabsTrigger>
  )
}

export const TabNavigation = ({ tabs }: { tabs: Tab[] }) => {
  const pathname = usePathname()
  const activeTab =
    tabs.find((tab) => pathname === tab.value)?.value || tabs[0]?.value

  return (
    <Tabs value={activeTab}>
      <TabsList>
        {tabs.map((tab) => (
          <TabLink key={tab.value} tab={tab} />
        ))}
      </TabsList>
    </Tabs>
  )
}
